module.exports = __webpack_public_path__ + "assets/img/DS-master (14).33795eb6.jpg";